<template>
  <div class="animated revealUp" style="zoom: 0.8">
    <div class="d-flex justify-content-between">
      <div class="mb-3">
        <div class="section-title">Merchandise Current Stock Report</div>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length ? 'shift-up' : ''">{{
              $tc("cinema", 1)
            }}</label>
            <multiselect
              :options="Cinemas"
              v-model="selectedCinema"
              :placeholder="''"
              label="cine_name"
              track-by="cine_id"
              :multiple="true"
              :close-on-select="false"
            ></multiselect>
          </div>
        </div>

        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedMerchandise.length ? 'shift-up' : ''"
              >Merchandise</label
            >
            <multiselect
              :options="AllMerchandiseItems"
              v-model="selectedMerchandise"
              :placeholder="''"
              label="merchandise_name"
              track-by="merchandise_id"
              :multiple="true"
              :close-on-select="false"
            ></multiselect>
          </div>
        </div>

        <div class="col-md-2 mb-3">
          <button class="btn-blue" @click.prevent.stop="onFetch()">
            {{ $t("Fetch") }}
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <template>
          <button
            class="btn-blue p-2 w"
            @click="$bvModal.show('updateMerchandiseStock')"
          >
            {{ $t("Upload Stock") }}
          </button>
        </template>
        <div
          v-if="VariantsStock && VariantsStock.length > 0"
          class="d-flex justify-content-end mb-4 align-items-center"
        >
          <div>{{ $t("download") }} as:</div>
          <a
            target="_blank"
            @click="getMerchandiseCurrentStock('Y')"
            title="Exports"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>
      <div class="">
        <table class="swc-report-table text-center border" border="1">
          <thead>
            <tr>
              <th class="text-left" style="width: 370px">Cinema Name</th>
              <th class="text-left">Merchandise Name</th>
              <th class="text-left">Variant Name</th>
              <th class="text-right">Stock Available</th>
              <th class="text-center">status</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(variantObj, variantIndex) in VariantsStock"
              :key="variantIndex"
            >
              <td class="text-left">
                {{ variantObj.cine_name }}
              </td>
              <td class="text-left">
                {{ variantObj.merchandise_name }}
              </td>
              <td class="text-left font-weight-bold">
                <div
                  v-if="variantObj.size_name && variantObj.color_name"
                  class="w-50"
                >
                  <span>{{ variantObj.size_name }}</span>
                  <span>-</span>
                  <span>{{ variantObj.color_name }}</span>
                </div>
                <span v-if="variantObj.size_name && !variantObj.color_name">{{
                  variantObj.size_name
                }}</span>
                <span v-if="!variantObj.size_name && variantObj.color_name">{{
                  variantObj.color_name
                }}</span>
              </td>
              <td class="text-right">
                {{ parseFloat(variantObj.stock_available) }}
              </td>
              <td class="text-center">
                <b-form-checkbox
                  :disabled="true"
                  v-model="variantObj.is_stock_disabled"
                  unchecked-value="Y"
                  value="N"
                  switch
                  class="j-checkbox"
                ></b-form-checkbox>
              </td>
            </tr>
            <tr v-if="VariantsStock.length == 0">
              <td colspan="5">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-modal
      id="updateMerchandiseStock"
      title="Upload Stock"
      hide-header
      hide-footer
      ref="updateMerchandiseStock"
    >
      <div class="col-12 text-center mb-4 pb-2 mt-3">
        <h6>{{ $t("Upload Stock") }}</h6>
      </div>

      <div class="col-lg-12 col-xl-12 mt-4 mb-1">
        <input
          type="file"
          id="fileInput"
          name="fileInput"
          placeholder="."
          @change="onChange"
          accept=".xlsx, .csv"
        />

        <label for="fileInput" class="file-label">
          <div v-if="file_name">File Attached.</div>
          <div v-else><u>click here</u> to upload.</div>
        </label>
      </div>

    
      <div class="col-lg-12 col-xl-12 mb-1 text-center">
        <button
          @click.prevent.stop="updateData"
          class="btn-blue"
          v-if="excelReaderData.length"
        >
          {{ $t("Submit") }}
        </button>
        <button
          @click.prevent.stop="$bvModal.hide('updateMerchandiseStock')"
          class="btn-blue"
        >
          Cancel
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import _ from "lodash";
import NoRecords from "@/components/Partials/NoRecords.vue";
import * as XLSX from "xlsx";
export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      isDragging: false,
      file: "",
      file_name: "",
      excelReaderData: [],
      VariantsStock: [],
      AllMerchandiseItems: [],
      selectedMerchandise: [],
      mainPayload: {
        cinema_id: null,
        merchandise_id: null,
      },
      btnDisbaled: false,
      searchCinema: "",
      isRoleID: true,
      isRoleID1: null,
      getitem: "",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      listView: true,
      Cinemas: [],
      selectedCinema: [],
      selectedReason: "",
      excelFile: "",
      pdfFile: "",
      selectedCinemaObject: {},

      debounce: null,
      searchValue: "",

      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
    };
  },
  computed: {},
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.isRoleID1 = this.secureStore.get("USINFO").role_id;

    const { merchandise_id } = this.$route.query;
    this.mainPayload["merchandise_id"] = merchandise_id || null;
    console.log("merchandise_id", merchandise_id);

    this.getCinemas(obj);
    this.getMerchandiseCurrentStock();
    this.getMerchandiseItems();
  },

  methods: {
    updateData() {
      if (this.excelReaderData && this.excelReaderData.length) {
        let body = {
          excelReaderData: this.excelReaderData,
        };

        let loader = this.$loading.show();

        MasterService.UploadMerchandiseStock(body)
          .then((response) => {
            const { data } = response;
            this.$refs["updateMerchandiseStock"].hide();
            if (data.status) {
              this.$toasted.show("Uploaded Successfully");
              this.getMerchandiseCurrentStock();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(() => {
            this.$refs["updateMerchandiseStock"].hide();
            this.$toasted.show("Uploaded Successfully");
            this.getMerchandiseCurrentStock();
          })
          .finally(() => {
            loader.hide();
          });
      } else {
        this.$toasted.show("No Valid Data to Upload");
      }
    },
     dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.onChange({ target: { files: e.dataTransfer.files } });
      this.isDragging = false;
    },
    onChange(event) {
      console.log(event.target.files);
      this.file = event.target.files ? event.target.files[0] : null;
      this.file = event.target.files ? event.target.files[0] : null;
      this.excelReaderData = [];
      this.file_name = event.target.files[0].name;

      console.log("this.file", this.file);

      let array = [
        "Cinema ID",
        "Merchandise ID",
        "Variant ID",
        "Cinema Name",
        "Merchandise Name",
        "Variant Name",
        "Stock Available",
      ];

      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
          console.log(data, "SCANNED DATA");
          data.map((z, index) => {
            if (index) {
              let obj = {};
              let array2 = [0, 1, 2, 3, 4, 5, 6];
              z.map((y, index2) => {
                let findIndex2 = array2.indexOf(index2);

                console.log("findIndex2", findIndex2);

                if (findIndex2 >= 0) {
                  array2.splice(findIndex2, 1);
                }
                if (array[index2]) {
                  let keyName = array[index2].toLowerCase().replace(/ /g, "_");
                  obj[keyName] = y || (index2 == 6 ? 0 : null);
                }
              });
              if (array2) {
                array2.map((k) => {
                  obj[array[k]] = k == 6 ? 0 : null;
                });
              }

              this.excelReaderData.push(obj);
            }
          });
          console.log(this.excelReaderData, "Before");
          let errCount = 0;
          let errMsg = ``;
          this.excelReaderData.map((_each) => {
            if (!_each["cinema_id"]) {
              errCount++;
              errMsg = `Cinema ID missing`;
            } else if (!_each["variant_id"]) {
              errCount++;
              errMsg = `Variant ID missing`;
            } else if (!_each["merchandise_id"]) {
              errCount++;
              errMsg = `Variant ID missing`;
            } else if (isNaN(String(_each["stock_available"]))) {
              errCount++;
              errMsg = `Please Provide Valid Stock Quantity`;
            }
          });
          if (errCount > 0) {
            this.excelReaderData = [];
            return this.$toasted.show(`Invalid File Data | ${errMsg}`);
          } else {
            this.excelReaderData = this.excelReaderData.filter((z) => {
              return (
                z.cinema_id &&
                z.variant_id &&
                z.variant_name &&
                z.merchandise_id
              );
            });
          }
          console.log(this.excelReaderData, "AFTER");
        };

        reader.readAsBinaryString(this.file);
      }
    },
    onFetch: function () {
      this.getMerchandiseCurrentStock();
    },
    getMerchandiseItems: function () {
      this.AllMerchandiseItems = [];
      let payload = {
        tableName: "ms_merchandise",
        merchandise_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.AllMerchandiseItems = data.Records.filter(
                (x) => x.is_combo_pack == "N"
              );
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    getMerchandiseCurrentStock(isExcel = "N") {
      let payload = {
        cinema_ids: this.selectedCinema.length
          ? this.selectedCinema.map((cine) => cine.cine_id)
          : [],
        merchandise_ids: this.selectedMerchandise.length
          ? this.selectedMerchandise.map((merch) => merch.merchandise_id)
          : [],
        isExcel: isExcel,
      };
      MasterService.GetMerchandiseCurrentStock(payload).then((response) => {
        const { data } = response;
        if (data.status && data.excelPath && isExcel == "Y") {
          window.open(data.excelPath, "_self");
        } else if (data.status && data.Records && data.Records.length) {
          this.VariantsStock = data.Records || [];
        } else {
          this.$toasted.show(data.message || "Something Went Wrong!");
        }
      });
    },
    getCinemas: function (cine_id) {
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectCinema: function (params, type = "select") {
      this.selectedCinema.push(params);
    },
    onSortValue(columnName, orderBy) {
      if (this.selectedid.length == 0) {
        return this.$toasted.show("Please select cinema");
      }
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getMerchandiseCurrentStock(this.selectedid);
    },
    onSearch: function () {
      this.getMerchandiseCurrentStock(this.selectedid);
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    goToRoute: function (path, { stock_in_id }) {
      this.$router.push({
        path: path,
        query: {
          stock_in_id: stock_in_id,
        },
      });
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        console.log("this.selectedid :", this.selectedid);
        this.getMerchandiseCurrentStock(this.selectedid);
      } else if (this.isRoleID1 == 1 || this.isRoleID1 == 2) {
        this.currentPage = event;
        this.getMerchandiseCurrentStock(this.selectedid);
      } else {
        this.currentPage = event;
        this.getMerchandiseCurrentStock(this.getitem);
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },
  },
};
</script>

<style>
.stockUOM-dropdowm .multiselect__content-wrapper {
  width: 160px !important;
}

.table-wrapper {
  /* overflow-x: scroll !important; */
}

.table-wrapper .list-view-table {
  /* width: auto!important; */
  table-layout: auto;
  /* white-space: nowrap; */
}

.table-wrapper .list-view-table th {
  padding: 5px 10px 5px 10px;
}

.bg-red {
  color: red;
  background-color: transparent !important;
}

.bg-green {
  color: green;
}

.bg-transparent {
  background-color: transparent !important;
  color: black !important;
}

.noVendorRate {
  opacity: 0.5;
  color: red;
  pointer-events: none;
}

.invalid_input {
  border: 1px solid red !important;
  border-radius: 10px;
}
.customer_drop_down {
  background-color: none !important;
}

.disableRefundBtn {
  opacity: 0.5;
  pointer-events: none;
}

.backup-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: calc(100% - 240px) !important;
}

.backup-box {
  height: 60px;
  width: 500px;
  border-radius: 10px;
  border: 2px dashed var(--primary);
  /* line-height: 50px; */
  color: var(--primary);
  font-size: 17px;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MechandiseComponents/MerchandiseCurrentStock.vue